import { translate } from '@/i18n/index'
const CANCELLATION_UNAVAILABLE_COPY = Object.freeze({
  online_cancellation_disabled: "portalPresentation.member_cancellation_not_available_via_the_mobile_app",
  cancellation_cutoff_passed: "portalPresentation.member_the_online_cancellation_window_has_closed_please_contact_the_club",
  reservation_terminal: "portalPresentation.member_this_reservation_can_no_longer_be_cancelled",
  reservation_not_found: "portalPresentation.member_this_reservation_could_not_be_found_please_contact_the_club",
})

const FALLBACK_COPY = "portalPresentation.member_cancellation_is_not_currently_available_please_contact_the_club"

/** Convert a stable machine reason to safe member copy while leaving the source value untouched. */
export function cancellationUnavailableMessage(reason, t = translate) {
  return t(CANCELLATION_UNAVAILABLE_COPY[String(reason || '').trim()] || FALLBACK_COPY)
}

